// extracted by mini-css-extract-plugin
export default {"image":"IndexCardImage_image__RJGLI"};